"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCooperativeSuggestedProducts = void 0;
const routes_1 = require("../../routes");
const updateCooperativeSuggestedProducts = (client) => async (params, payload) => {
    const associated_product_ids = 'associated_product_ids' in payload ? payload.associated_product_ids : [payload.associated_product_id];
    const response = await client.put(routes_1.ENDPOINTS.UPDATE_DISTRIBUTOR_SUGGESTED_PRODUCTS.applyParams(params), { associated_product_ids });
    return response.data;
};
exports.updateCooperativeSuggestedProducts = updateCooperativeSuggestedProducts;
